import React from 'react';

import { Link } from 'react-router-dom';

import PhoneSearch from '../components/PhoneSearch';

import RecentReports from '../components/RecentReports';



function Home() {

  return (

    <div className="container mx-auto px-4 py-8">

      <div className="text-center mb-8">

        <h1 className="text-4xl font-bold mb-4">Welcome to WhoDatNumber</h1>

        <p className="text-xl text-gray-600">

          Look up any phone number to see who's calling you

        </p>

      </div>



      <PhoneSearch />



      <RecentReports />



      <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-8">

        <div className="p-6 bg-white rounded-lg shadow">

          <h3 className="text-xl font-semibold mb-2">Search Numbers</h3>

          <p className="text-gray-600">

            Quickly search any phone number to see reports and information.

          </p>

        </div>



        <div className="p-6 bg-white rounded-lg shadow">

          <h3 className="text-xl font-semibold mb-2">Report Calls</h3>

          <p className="text-gray-600">

            Help the community by reporting suspicious or unwanted calls.

          </p>

        </div>



        <Link

          to="/learn"

          className="p-6 bg-white rounded-lg shadow hover:ring-2 hover:ring-blue-100 transition block"

        >

          <h3 className="text-xl font-semibold mb-2">Protect Yourself</h3>

          <p className="text-gray-600">

            Free guides on scam calls, red flags, and securing your accounts.

          </p>

          <span className="inline-block mt-3 text-sm font-medium text-blue-600">

            Read safety guides →

          </span>

        </Link>

      </div>



      <div className="mt-8 grid grid-cols-1 md:grid-cols-3 gap-4">

        <Link

          to="/learn/trace-unknown-phone-number"

          className="p-4 border border-gray-200 rounded-lg hover:border-blue-200 bg-white"

        >

          <h4 className="font-semibold text-gray-900">Trace unknown numbers</h4>

          <p className="text-sm text-gray-600 mt-1">Step-by-step investigation guide</p>

        </Link>

        <Link

          to="/learn/protecting-yourself-phone-scams-australia"

          className="p-4 border border-gray-200 rounded-lg hover:border-blue-200 bg-white"

        >

          <h4 className="font-semibold text-gray-900">Avoid phone scams (AU)</h4>

          <p className="text-sm text-gray-600 mt-1">Expert tips for Australians</p>

        </Link>

        <Link

          to="/learn/password-managers"

          className="p-4 border border-gray-200 rounded-lg hover:border-blue-200 bg-white"

        >

          <h4 className="font-semibold text-gray-900">Password managers</h4>

          <p className="text-sm text-gray-600 mt-1">Protect accounts after a scam call</p>

        </Link>

      </div>

    </div>

  );

}



export default Home;



